import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=b6324d6a&scoped=true&lang=pug"
import script from "./CommentForm.vue?vue&type=script&lang=ts"
export * from "./CommentForm.vue?vue&type=script&lang=ts"
import style0 from "./CommentForm.vue?vue&type=style&index=0&id=b6324d6a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6324d6a",
  null
  
)

export default component.exports